module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/_library.js
// module id = ../../node_modules/core-js/modules/_library.js
// module chunks = 18